import Discovery from './Discovery';
import List from './List';
import * as Styles from './styles';

const PromptTemplates = () => {
  return (
    <Styles.Wrapper>
      <Discovery />
      <List />
    </Styles.Wrapper>
  );
};

export default PromptTemplates;
